import { EmbedFallback } from 'components/PostEmbed/EmbedFallback';
import { Post } from 'lib/types/posts';

interface Props {
  post: Post;
}

export function LinkedinEmbed({ post }: Props) {
  const linkedinShareId = post.attributes?.find((attribute) => attribute.attribute === 'linkedinShareId')?.value;
  if (!linkedinShareId) {
    return <EmbedFallback post={post} />;
  }

  return (
    <div>
      <iframe
        src={`https://www.linkedin.com/embed/feed/update/${linkedinShareId}?collapsed=1`}
        height="646"
        width="100%"
        title="Embedded post"
      />
    </div>
  );
}
